import styled from 'styled-components'

export interface INotificationTitleProps {}

export const NotificationTitleStyled = styled.div<INotificationTitleProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  font-weight: ${(props) => props.theme.fontWeights.semibold};
`
